// /plugins/fetch.js
import { Message } from 'element-ui'
import CryptoJS from 'crypto-js'
import MD5 from 'js-md5'
import { JSEncrypt } from 'js-encrypt'

function isRef(r) {
  return !!(r && r.__v_isRef === true)
}

function convertObj(data = {}, isSort = false) {
  var _result = []
  for (var key in data) {
    var value = isRef(data[key]) ? data[key].value : data[key]
    if (value === null || typeof value === 'undefined') continue
    if (Array.isArray(value)) {
      value.forEach(function (_value, index) {
        if (Object.prototype.toString.call(_value) == '[object Object]') {
          _result.push(key + '=' + convertObj(_value, true))
        } else if (Array.isArray(_value)) {
          _result.push(key + '=' + convertObj({ key: _value }, false))
        } else {
          _result.push(key + '[' + index + ']' + '=' + _value)
        }
      })
    } else if (Object.prototype.toString.call(value) == '[object Object]') {
      _result.push(key + '=' + convertObj(value, true))
    } else {
      _result.push(key + '=' + value)
    }
  }
  if (isSort) {
    let maps = {}
    _result.forEach((item) => {
      let [k, val] = item.split('=')
      if (maps[k]) {
        maps[k].push(val)
      } else {
        maps[k] = [val]
      }
    })
    let mapKeySort = Object.keys(maps).sort()
    return mapKeySort.map((k) => maps[k].join('')).join('')
  }
  return _result
    .map((item) => {
      return item.substring(item.indexOf('=') + 1)
    })
    .join('')
}

function genKey(length = 16) {
  const random = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  let str = ''
  for (let i = 0; i < length; i++) {
    str = str + random.charAt(Math.random() * random.length)
  }
  return str
}

// ==== 从 #base/utils/crypto.ts 复制的必要工具函数 ====
const Crypto = {
  encrypt(word, keyStr) {
    if (Object.prototype.toString.call(word) === '[object Object]') {
      word = JSON.stringify(word)
    }
    keyStr = keyStr || 'abcdefgabcdefg12'
    const key = CryptoJS.enc.Utf8.parse(keyStr)
    const srcs = CryptoJS.enc.Utf8.parse(word)
    const encrypted = CryptoJS.AES.encrypt(srcs, key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    })
    return encrypted.toString()
  },
  decrypt(word, keyStr) {
    keyStr = keyStr || 'abcdefgabcdefg12'
    const key = CryptoJS.enc.Utf8.parse(keyStr)
    const decrypt = CryptoJS.AES.decrypt(word, key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    })
    return CryptoJS.enc.Utf8.stringify(decrypt).toString()
  },
  getMd5(str) {
    return MD5(str).toString()
  },
  base64Encode(val) {
    const encodedWord = CryptoJS.enc.Utf8.parse(val)
    const encoded = CryptoJS.enc.Base64.stringify(encodedWord)
    return encoded
  }
}

// ==== 从 #base/utils/rsa.ts 复制的必要工具函数 ====
const RSA = {
  RSAencrypt(pas) {
    const PUBLIC_KEY =
      'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQC7GW1zgx9/ssgCjoZhuCvISy5Ns9T2UgAzjJqS2uTGuCVtZsN3TE5wd4OIeiVG2TVDH2Gxlzrxd5jg7P6IiUKqsliSdZxx/ceqLDawKgvO8mJ+hJJsuIxSL7Bi6T0p+xH6ibw4orGfCFUJhGryE9hqp9qTRiHOMvgC2si1VqrgaQIDAQAB'
    const jse = new JSEncrypt()
    jse.setPublicKey(PUBLIC_KEY)
    return jse.encrypt(pas)
  }
}

// 与 H5 端 useHttp.ts 中一致的加密相关逻辑
const randomKey = genKey()

function getSign(params, uuid, timestamp) {
  const queryString = `${timestamp}${Crypto.base64Encode(convertObj(params, true))}`.replace(/[+]/g, '-').replace(/\//g, '_')
  return Crypto.getMd5(Crypto.encrypt(queryString, uuid))
}

export default function ({ $config }, inject) {
  // 创建一个带拦截功能的 fetch
  const request = async ({ url, options = {}, method }) => {
    const headers = options.headers || {}
    const params = options.params || null
    const body = options.body || null
    let finalUrl = `${process.env.TV_BASE_URL}${url}`
    if (method.toUpperCase() === 'GET' && params) {
      const qs = new URLSearchParams(params).toString()
      finalUrl += `?${qs}`
    }

    let finalBody = null
    if (body && method.toUpperCase() !== 'GET') {
      // 支持 body 是对象
      finalBody = typeof body === 'object' ? JSON.stringify(body) : body
    }

    // ===== 生成与 useHttp.ts 一致的加密请求头字段 =====
    const timestamp = new Date().getTime()
    const lowerMethod = method && method.toLowerCase()
    const payload = lowerMethod === 'get' ? params : body
    const sign = getSign(payload, randomKey, timestamp)
    const aesKey = RSA.RSAencrypt(randomKey)

    // ===== 请求前扩展（添加公共 Header） =====
    const commonHeaders = {
      'Content-Type': 'application/json',
      // 与 H5 端字段保持一致的生成逻辑，这里按 TV 约定使用小写 key
      currenttime: timestamp.toString(),
      sign,
      aeskey: aesKey,
      ...headers
    }

    // 如果你有 token，也可以在这里附加
    // headers.Authorization = `Bearer ${token}`

    const finalOptions = {
      method,
      headers: commonHeaders,
      body: finalBody
    }

    try {
      // ===== 发起请求 =====
      const res = await fetch(finalUrl, finalOptions)

      if (!res.ok) {
        const err = await res.json()
        throw err
      }
      const data = await res.json()
      if (data.code != '00000') {
        throw data
      }
      // return res.json()
      return data
    } catch (err) {
      // ===== 全局错误处理点 =====
      console.log(err)
      Message.error(err.message || err.status || err.msg)
    }
  }

  // 注入到 Nuxt 中（客户端 + 服务端均可用）
  inject('tvFetch', request)
}
